import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AsyncFunction } from "../../functions/AsyncFunction";

// Stateの初期状態
const initialState = {
    email_address: "",
    send: false,
    origin: window.location.origin,
};

// Sliceを生成する
const slice = createSlice({
    name: "PasswordSetting",
    initialState,
    reducers: {
        PasswordSetting_initialize: () => initialState,
        PasswordSettingSet: (state, action) => {
            const name = action.payload[0];
            const value = action.payload[1];
            state[name] = value;
        },
    },
});

//パスワード再設定メール送信
export const PasswordSettingMail = function (arg) {
    const params = {
        url: "/api/PasswordSettingMail",
        method: "PUT",
        params: { ...arg },
        type_name: "PasswordSettingMail",
    };
    return AsyncFunction(params);
};

// Reducerをエクスポートする
export default slice.reducer;

// Action Creatorsをエクスポートする
export const { PasswordSetting_initialize, PasswordSettingSet } = slice.actions;
